"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _Link = require("../Link");
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.htmlAttrs, _utils.viewProps]);

// The ExpandCollapseControl has all the appropriate role, a11y, press handling etc
// and a more appropriate press area, defer interaction handling to it.
const presentationOnly = {
  accessibilityRole: null,
  // Treat as regular flow content with the Control
  pointerEvents: 'none',
  // Stop RNW from stopping clicks from bubbling to Control
  focusable: false // Stop RNW from setting tabIndex={0}: focus goes to Control only
};
const ExpandCollapseMiniControl = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    pressableState,
    collapseTitle,
    expandTitle = collapseTitle,
    iconPosition = 'right',
    tokens,
    variant = {},
    ...rest
  } = _ref;
  const {
    expanded,
    hover,
    focus,
    pressed
  } = pressableState || {};
  const {
    quiet
  } = variant;
  const isFocusVisible = _Platform.default.OS === 'web' ? focus && !pressed && !hover : expanded;
  const linkTokens = (0, _ThemeProvider.useThemeTokens)('Link', {}, {
    ...variant,
    quiet
  }, {
    focus: isFocusVisible,
    hover,
    pressed
  });
  const {
    size,
    icon
  } = (0, _ThemeProvider.useThemeTokens)('ExpandCollapseMiniControl', tokens, variant, {
    expanded,
    focus
  });

  // Choose hover styles when any part of Control is hoverred
  const appearance = {
    ...variant,
    hover
  };
  const getTokens = linkState => {
    const {
      hover: linkHover
    } = linkState || {};
    const isHovered = hover || linkHover;
    if (_Platform.default.OS !== 'web') {
      return {
        iconTranslateY: -1
      };
    }
    if (isHovered) {
      // Include vertical icon animation on hover alongside built-in Link theme, the size is size4
      return {
        iconTranslateY: (expanded ? -1 : 1) * size
      };
    }
    return {};
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
    variant: appearance,
    icon: icon,
    iconPosition: iconPosition,
    tokens: linkState => ({
      ...linkTokens,
      ...getTokens(linkState)
    }),
    ref: ref,
    ...presentationOnly,
    ...selectProps(rest),
    children: expanded ? expandTitle : collapseTitle
  });
});
ExpandCollapseMiniControl.displayName = 'ExpandCollapseMiniControl';
ExpandCollapseMiniControl.propTypes = {
  ...selectedSystemPropTypes,
  ..._Link.Link.propTypes,
  /**
   * Optional function to call on pressing the panel's control, in addition to opening or closing the panel
   */
  onPress: _propTypes.default.func,
  /**
   * ExpandCollapseMiniControl title when expanded
   */
  expandTitle: _propTypes.default.string.isRequired,
  /**
   * ExpandCollapseMiniControl title when collapsed
   */
  collapseTitle: _propTypes.default.string.isRequired,
  /**
   * React Native's `Pressable`'s state object
   */
  pressableState: _propTypes.default.object,
  /**
   * Optional variant object to override the default theme tokens
   */
  variant: _propTypes.default.object
};
var _default = exports.default = ExpandCollapseMiniControl;